import type { BigFraction } from "./BigFraction.js";

export const opposite = (value: BigFraction | null) => value?.neg() ?? null;

export const oppositeNumber = (value: number | null) =>
  value == null ? null : -value;
